module.exports = __webpack_public_path__ + "img/product-specs-2.211564d0.svg";